// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.containerIconAnswer {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  position: fixed;
  margin-top: 15px;
}

.containerIconAnswerDash {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  position: absolute;
  top: 56px;
}

.mensageIconAnswer {
  display: block;
  z-index: 1;
  font-size: 13px;
  background-color: #ffffff;
  border-radius: 4px;
  box-shadow: 1px 2px 2px 4px #efefef;
  padding: 10px;
  font-style: italic;
}

.iconAnswerImg {
  cursor: pointer;
}

.iconAnswerImg:hover {
  filter: brightness(0) saturate(100%) invert(27%) sepia(98%) saturate(624%)
    hue-rotate(164deg) brightness(91%) contrast(102%);
}

.iconAnswerButton {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/componentes/iconeAnswer/iconAnswer.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,UAAU;EACV,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,mCAAmC;EACnC,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;qDACmD;AACrD;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,eAAe;AACjB","sourcesContent":[".containerIconAnswer {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  position: fixed;\n  margin-top: 15px;\n}\n\n.containerIconAnswerDash {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  position: absolute;\n  top: 56px;\n}\n\n.mensageIconAnswer {\n  display: block;\n  z-index: 1;\n  font-size: 13px;\n  background-color: #ffffff;\n  border-radius: 4px;\n  box-shadow: 1px 2px 2px 4px #efefef;\n  padding: 10px;\n  font-style: italic;\n}\n\n.iconAnswerImg {\n  cursor: pointer;\n}\n\n.iconAnswerImg:hover {\n  filter: brightness(0) saturate(100%) invert(27%) sepia(98%) saturate(624%)\n    hue-rotate(164deg) brightness(91%) contrast(102%);\n}\n\n.iconAnswerButton {\n  background: none;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
